import s from './style.css';
import cn from 'classnames';

const Container = ({ children, snug }) => (
	<div className={cn(s.root, { [s.snug]: snug })}>{children}</div>
);

export default Container;



// WEBPACK FOOTER //
// ./components/Container/index.js